export default __webpack_public_path__ + "static/media/About_BG-01.ac404318.png";